module.exports = __webpack_public_path__ + "static/media/ic_avatar.212c020d.svg";